import { Box, Button } from '@mui/material';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';

type EmptyListProps = {
  title: string;
  description: string;
  action: string;
  onActionClicked: () => void;
};

export const CmsEmptyList = (props: EmptyListProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box component='img' src='/public/assets/images/no_saved_item.svg' />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          color: '#626a7a',
          mt: 10,
        }}
      >
        <Typography
          sx={{ fontSize: 24, fontWeight: 600, mb: 5, textAlign: 'center' }}
        >
          <FormattedMessage id={props.title} />
        </Typography>
        <Typography sx={{ mb: 10, alignSelf: 'flex-start' }}>
          <FormattedMessage id={props.description} />
        </Typography>
        <Button
          variant={'contained'}
          disableElevation
          onClick={props.onActionClicked}
          sx={{
            borderRadius: 8,
            ml: 4,
            px: 11,
            py: 4,
            fontSize: 'inherit',
          }}
        >
          <FormattedMessage id={props.action} />
        </Button>
      </Box>
    </Box>
  );
};
